import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { SelectField, NumberField } from 'react-admin';

import { anomalyDeviationDirectionChoices } from '../../../constants/anomalyDeviationDirections';
import { timePeriodChoices } from '../../../constants/timePeriods';
import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';

const SimpleAnomalyDetection = () => (
  <Grid
    alignItems="baseline"
    size={{
      xs: 12,
      sm: 6,
      lg: 4,
    }}
  >
    <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Transaction types configuration
      </Typography>
      <TransactionTypeConfigurationField
        source="ruleParameters.transactionTypeConfiguration"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Transaction monitoring mode
      </Typography>
      <SelectField
        choices={transactionMonitoringModesChoices}
        source="ruleParameters.transactionMonitoringMode"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Deviation Percentage
      </Typography>
      <Typography sx={{ fontSize: 10 }}>
        <NumberField
          source="ruleParameters.threshold"
          sx={{ fontSize: 10 }}
        />
        %
      </Typography>

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Deviation Direction
      </Typography>
      <SelectField
        choices={anomalyDeviationDirectionChoices}
        source="ruleParameters.deviationDirection"
        label="Deviation Direction"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Minimum number of transactions
      </Typography>
      <NumberField source="ruleParameters.minimumNumberOfObservations" sx={{ fontSize: 10 }} />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Minimum Usage
      </Typography>
      <NumberField source="ruleParameters.minimumUsageTime.amount" sx={{ fontSize: 10 }} />
      <SelectField
        choices={timePeriodChoices}
        source="ruleParameters.minimumUsageTime.unit"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Period To Consider
      </Typography>
      <NumberField source="ruleParameters.periodToConsider.amount" sx={{ fontSize: 10 }} />
      <SelectField
        choices={timePeriodChoices}
        source="ruleParameters.periodToConsider.unit"
        sx={{ fontSize: 10 }}
      />

      <Typography sx={{ fontWeight: 'bold', fontSize: 10 }}>
        Window Period
      </Typography>
      <NumberField source="ruleParameters.windowPeriod.amount" sx={{ fontSize: 10 }} />
      <SelectField
        choices={timePeriodChoices}
        source="ruleParameters.windowPeriod.unit"
        sx={{ fontSize: 10 }}
      />
    </Box>
  </Grid>

);

export default SimpleAnomalyDetection;
